import React from 'react';

interface Props {
  /** Bounding rect of the spotlight target. Null → full-screen darken with no cutout. */
  rect: DOMRect | null;
}

const PADDING = 2;
const RADIUS = 8;

// Overlay is intentionally non-interactive — clicking the dim area used to
// fire skip(), which felt abrupt (users dismissed the tour by accident
// while pointing at the spotlit element). Explicit exits remain: the × in
// the card header, the Skip / Done CTAs, and Esc. `pointer-events-none`
// also lets clicks pass through to the actual UI underneath the dim area
// where the tour isn't blocking interaction.
export const TourOverlay: React.FC<Props> = ({ rect }) => {
  return (
    <svg
      className="pointer-events-none fixed inset-0 z-[10000]"
      width="100%"
      height="100%"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <mask id="tour-overlay-mask">
          <rect width="100%" height="100%" fill="white" />
          {rect && (
            <rect
              x={rect.x - PADDING}
              y={rect.y - PADDING}
              width={rect.width + PADDING * 2}
              height={rect.height + PADDING * 2}
              rx={RADIUS}
              ry={RADIUS}
              fill="black"
            />
          )}
        </mask>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill="rgba(15, 23, 42, 0.55)"
        mask="url(#tour-overlay-mask)"
      />
    </svg>
  );
};
